<template lang="pug">
.base-option(:class="[disabled ? '' : 'cursor-pointer', isHighlighted ? 'bg-form-item-placeholder' : '']", :data-option-value="String(value)", @click.stop="onClick")
  slot(:label="label", :value="value", :data="data", :isSelected="isSelected")
    span.truncate {{ label }}
</template>

<script setup>
import { inject, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  value: undefined,
  label: String,
  data: [String, Object],
  disabled: Boolean,
})

const selectContext = inject('Select')

const isSelected = computed(() => {
  return selectContext.isSelected(props.value)
})

// 底色跟著 highlight（未選值時為定位錨點），slot 的 isSelected 維持真正的選取狀態
const isHighlighted = computed(() => {
  return selectContext.isHighlighted ? selectContext.isHighlighted(props.value) : isSelected.value
})

const onClick = () => {
  if (props.disabled) return

  // 調用父組件的選擇方法
  selectContext.onSelect(props.value)
}

// 組件掛載時註冊自己
onMounted(() => {
  selectContext.registerOption({
    value: props.value,
    label: props.label,
    data: props.data,
    disabled: props.disabled,
  })
})

// 組件卸載時取消註冊
onUnmounted(() => {
  selectContext.unregisterOption(props.value)
})
</script>

<style scoped lang="scss"></style>
